import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { Check, X } from 'react-feather';

// TODO: stop breaking the vertical rythm
export const noIcon = <X size="28" strokeWidth={3} color={ouiStyle.Constants.Colors.primary} />;
export const yesIcon = <Check size="28" strokeWidth={3} color={ouiStyle.Constants.Colors.accent} />;
